import React from 'react'

function QuickLinks() {
    return (
        <div className="mt-8">
            <div className="px-4 py-2 md:px-6 mx-4 rounded-lg shadow bg-white">
                <h2 className=" mb-5 p-2 text-2xl font-bold text-gray-700 border-b">Quick Links</h2>
                <div className="md:flex md:justify-start">
                    <div className="mr-6 mb-4">
                        <button className="px-6 py-2 w-full rounded inline-flex items-center justify-center bg-transparent text-purple-700 font-semibold border-2 border-purple-700 hover:bg-purple-700 hover:text-white">
                            <span className="uppercase tracking-wide">Top Brands</span>
                        </button>
                    </div>
                    <div className="mr-6 mb-4">
                        <button className="px-6 py-2 w-full rounded inline-flex items-center justify-center bg-transparent text-purple-700 font-semibold border-2 border-purple-700 hover:bg-purple-700 hover:text-white">
                            <span className="uppercase tracking-wide">New Tractors</span>
                        </button>
                    </div>
                    <div className="mr-6 mb-4">
                        <button className="px-6 py-2 w-full rounded inline-flex items-center justify-center bg-transparent text-purple-700 font-semibold border-2 border-purple-700 hover:bg-purple-700 hover:text-white">
                            <span className="uppercase tracking-wide">Implements</span>
                        </button>
                    </div>
                    <div className="mr-6 mb-4">
                        <button className="px-6 py-2 w-full rounded inline-flex items-center justify-center bg-transparent text-purple-700 font-semibold border-2 border-purple-700 hover:bg-purple-700 hover:text-white">
                            <span className="uppercase tracking-wide">Compare</span>
                        </button>
                    </div>
                    <div className="mr-6 mb-4">
                        <button className="px-6 py-2 w-full rounded inline-flex items-center justify-center bg-transparent text-purple-700 font-semibold border-2 border-purple-700 hover:bg-purple-700 hover:text-white">
                            <span className="uppercase tracking-wide">Get Tractor price </span>
                        </button>
                    </div>
                    <div className="mr-6 mb-4">
                        <button className="px-6 py-2 w-full rounded inline-flex items-center justify-center bg-transparent text-purple-700 font-semibold border-2 border-purple-700 hover:bg-purple-700 hover:text-white">
                            <span className="uppercase tracking-wide">Easy Finance</span>
                        </button>
                    </div>
                    
                    
                </div>

            </div>
        </div>
    )
}

export default QuickLinks
